<template>
  <div class="create-password-container">
    <div class="header-container">
      <span class="title">{{ $t('hm.title.dashboard') }}</span>
    </div>
    <Language/>
    <div class="page-body">
      <div class="title">{{ $t('onboarding.common.loginTitle') }}</div>
      <div class="form-container">
        <div class="email-address">
          <span class="label">{{ $t('hm.label.userName') }}</span>
          <el-input class="input" v-model="loginInfo.name" name="name" placeholder=""/>
          <span v-if="showNameTips" class="tips">{{ emailErrorTips }}</span>
        </div>
        <div class="password">
          <span class="label">{{ $t('hm.label.password') }}</span>
          <el-input class="input" v-model="loginInfo.password" name="password" show-password placeholder=""/>
          <span v-if="!loginInfo.password && showPasswordTips" class="tips">{{ $t('common.message.requiredFormField') }}</span>
        </div>
        <div class="agreement-policy">
          <el-checkbox v-model="policy" class="policy-checkbox" ></el-checkbox>
          <div class="policy-container">
            <div class="policy" :class="isEn && 'is-en'">
              <span>{{ $t('login.company.register.candidate.policy.body') }}</span>
              <a class="policy-link" href="/tos/" target="_blank">{{ $t('login.company.register.candidate.policy.link1') }}</a>
              <span>& </span>
              <a class="policy-link" href="/policy/" target="_blank">{{ $t('login.company.register.candidate.policy.link2') }}</a>
            </div>
          </div>
          <span v-if="showPolicyTips" class="tips">{{ policyErrorTips }}</span>
        </div>
        <div class="forget-password">
          <a
            class="forget-password-link"
            @click="handleForgetPassword"
          >{{ $t('hm.label.forgetPassword') }}
          </a>
        </div>
      </div>
    </div>
    <div class="button-container">
      <div class="button submit" @click="handelLogin">{{ $t('hm.btn.toHMDashboard') }}</div>
      <div class="button forget-password" @click="handleForgetPassword">{{ $t('hm.btn.resend') }}</div>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import Language from '../common/language.vue'
import { emailRegexp } from '@/utils/validator'
import mixin from '../common/mixin'
import { passwordEncrypt } from '@/utils/rsa'

export default {
  mixins: [mixin],
  components: {
    Language
  },
  data () {
    return {
      loginInfo: {
        name: '',
        password: ''
      },
      policy: false,
      bannerUrl: '',
      showNameTips: false,
      showPolicyTips: false,
      showPasswordTips: false,
      languageOptions: [{ id: 'zh', text: '简体中文' }, { id: 'en', text: 'English' }]
    }
  },
  computed: {
    backUrl () {
      return this.$route.query.backUrl
    },
    emailErrorTips () {
      if (this.loginInfo.name && !emailRegexp.test(this.loginInfo.name)) {
        return this.$t('common.message.invalidEmail')
      } else if (this.loginInfo.name) {
        return ''
      } else {
        return this.$t('common.message.requiredFormField')
      }
    },
    policyErrorTips () {
      if (!this.policy) {
        return this.$t('common.message.needLoginAgreePolicy')
      }
      return ''
    }
  },
  async created () {
    this.initData()
  },
  methods: {
    ...mapActions('hm', ['hmLogin', 'setToken']),
    initData () {
      if (this.$route.query.logout) {
        this.setToken('')
      }
      if (this.$route.query.email) {
        this.emailAddress = this.$route.query.email
      }
    },
    async handelLogin (isValid) {
      if (!this.loginInfo.name || !this.loginInfo.password) {
        this.showNameTips = !this.loginInfo.name
        this.showPasswordTips = !this.loginInfo.password
        return
      }
      if (!emailRegexp.test(this.loginInfo.name)) {
        this.showNameTips = true
        return
      }
      if (!this.policy) {
        this.showPolicyTips = !this.policy
        return
      }
      this.$eventBus.$emit('showLoading', true)
      try {
        const params = {
          email_address: this.loginInfo.name,
          password: passwordEncrypt(this.loginInfo.password)
        }
        const resp = await this.hmLogin(params)
        if (resp) {
          if (resp.success) {
            if (this.backUrl) {
              window.location.href = this.backUrl
            }
            this.$router.push({ name: 'hm-dashboard' })
          } else {
            if (resp.lock_countdown_time) {
              this.$message.error(this.$t('login.common.message.lockAccount.countdownTime', { countdownTime: parseInt(resp.lock_countdown_time) }))
            } else if (resp.lock_after) {
              this.$message.error(this.$t('login.common.message.lockAccount.lockAfter', { times: parseInt(resp.lock_after) }))
            } else {
              this.$message.error(this.$t('login.common.message.accountOrPasswordIsWrong'))
            }
          }
        }
      } finally {
        this.$eventBus.$emit('showLoading', false)
      }
    },
    handleForgetPassword () {
      this.$router.push({ name: 'forgetPasswordPage' })
    }
  }
}
</script>
<style lang="scss" scoped>
.create-password-container {
  height: 100vh;
  background-color: #f7f7f7;

  .header-container {
      background-color: #0b0d1a;
      display: flex;
      justify-content: center;
      width: 100%;

      .title {
          text-align: center;
          color: #FFFFFF;
          font-size: 18px;
          margin: 40px 0;
      }
  }

  .page-body {
    display: flex;
    flex-direction: column;
    padding: 0 20px;
    align-items: flex-start;

    .title {
      padding: 10px 0px 10px 20px;
      font-weight: bolder;
      text-align: center;
      font-size: 24px;
    }

    .form-container {
      background-color: #FFFFFF;
      width: 100%;
      padding: 30px 0;

      &> div {
        display: flex;
        padding: 0 20px;
        flex-direction: column;
        align-items: flex-start;
      }

      .email-address {
        flex: 1;
        position: relative;
      }

      .password {
        flex: 5;
        margin-top: 20px;
        margin-bottom: 30px;
        position: relative;
      }

      .forget-password {
        position: relative;
        .forget-password-link {
          position: absolute;
          right: 15px;
          top: -35px;
          font-size: 14px;
          cursor: pointer;
          color: #0096cc;
          text-decoration: none;
        }

        .forget-password-link:hover{
          color: #405660;
        }
      }

      .agreement-policy {
        flex: 1;
        margin-top: 20px;
        margin-bottom: 70px;
        position: relative;
        .policy-link {
          color: #0096cc;
        }

        .policy-checkbox {
          ::v-deep {
            .el-checkbox__input {
              line-height: 0;
              &.is-checked {
                .el-checkbox__inner {
                  background-color: #fff;
                  border-color: #b2b2b2;
                }
              }

              &.is-focus {
                .el-checkbox__inner {
                  border-color: #b2b2b2;
                }
              }
              .el-checkbox__inner {
                width: 20px;
                height: 20px;
                border-color: #b2b2b2;
                border-radius: 0;

                &:hover {
                  border-color: #b2b2b2;
                }

                &::after {
                  width: 6px;
                  height: 14px;
                  border-width: 3px;
                  border-color: #4d4d4d;
                  top: 0;
                  left: 5px;
                }
              }
            }
          }
        }
      }

      .policy-checkbox {
        white-space: nowrap;
        font-size: 14px;
      }

      .policy-container{
        position: absolute;
        left: 50px;
        span {
          font-size: 14px;
        }
        a {
          font-size: 14px;
        }
      }

      .label {
        white-space: nowrap;
        font-size: 16px;
        color: #b5b5b5;
        text-align: right;
      }

      .input {
        margin: 10px 0;
      }

      .tips {
        color: red;
        font-size: 14px;
        line-height: 1;
        padding-top: 25px;
      }

      ::v-deep .el-input {

        .el-input__inner {
          border: 0;
          background-color: #f7f7f7;
          color: #000000;
        }
      }
    }
  }

  .button-container {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 0 20px;
    margin-top: 15px;

    .button {
      background-color: rgb(173, 173, 173);
      padding: 6px 20px;
      min-width: 200px;
      height: 28px;
      line-height: 31px;
      color: #FFFFFF;
      font-size: 16px;
      white-space: nowrap;
      text-align: center;
      cursor: pointer;

      &.submit {
        margin: 15px 0;
        background-color: #0096cc;
      }
    }
  }
}
</style>
